import React from 'react';

export default function CheckoutCancel() {
  // Check if there's a stored Stripe URL in sessionStorage
  const storedStripeUrl = sessionStorage.getItem('stripeCheckoutUrl');
  const hasStripeUrl = !!storedStripeUrl;

  const handleGoBack = () => {
    if (storedStripeUrl) {
      window.location.href = storedStripeUrl;
    }
  };

  return (
    <div className="checkout-cancel-container" style={{padding: '20px', textAlign: 'center'}}>
      <div>
        <div style={{fontSize: '48px', color: '#dc3545', marginBottom: '20px'}}>✕</div>
        <h2 style={{color: '#dc3545', marginBottom: '20px'}}>Payment Cancelled</h2>
        <p style={{fontSize: '16px', color: '#6c757d', marginBottom: '30px'}}>
          Your payment was cancelled. No charges have been processed.
        </p>
        <div style={{display: 'flex', gap: '10px', justifyContent: 'center'}}>
          {hasStripeUrl && (
            <button
              type="button"
              onClick={handleGoBack}
              style={{
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '12px 24px',
                fontSize: '16px',
                cursor: 'pointer',
              }}
            >
              Go Back
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
